import { Container as MuiContainer, styled } from '@mui/material';

const sizes = {
    sm: '365px',
    md: '784px',
    lg: '992px',
    xl: '1200px',
    default: '100%',
};

type Size = keyof typeof sizes;

const OWContainer = styled(MuiContainer)<{ size?: Size }>(({ size = 'default', theme }) => ({
    flexGrow: 1,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    maxWidth: sizes[size],
    [theme.breakpoints.down('md')]: {
        width: sizes.default,
    },

    // Reseting responsive breakpoints
    [theme.breakpoints.up('lg')]: {
        maxWidth: sizes[size],
    },
    [theme.breakpoints.up('xl')]: {
        maxWidth: sizes[size],
    },
}));

export default OWContainer;
